'use strict'

module.exports = {
  NODE_ENV: '"prod"',
  ROOT_API: '"//api.ezfixd.com"',
  SITE_URL: '"//www.page.ezfixd.com"',
  DASHBOARD_URL: '"//app.ezfixd.com"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 1